import { ArrowDropDown } from "@mui/icons-material";
import { Input } from "@mui/material";
import {
  UseDateFieldProps,
  BaseSingleInputFieldProps,
  FieldSection,
  DateValidationError,
  DatePickerProps,
  DatePicker,
} from "@mui/x-date-pickers";
import dayjs, { Dayjs } from "dayjs";
import { useState } from "react";

interface SeldectFieldProps
  extends UseDateFieldProps<Dayjs>,
    BaseSingleInputFieldProps<
      Dayjs | null,
      Dayjs,
      FieldSection,
      DateValidationError
    > {
  setOpen?: React.Dispatch<React.SetStateAction<boolean>>;
}

function SelectField(props: SeldectFieldProps) {
  const { setOpen, disabled, value, InputProps: { ref } = {} } = props;
  const todayDate = new Date();

  return (
    <Input
      className="input-field"
      disabled={disabled}
      ref={ref}
      readOnly
      sx={{
        width: "320px",
        bgcolor: "white",
        p: 2,
        "@media (max-width: 1250px)": {
          width: "100%",
          display: "flex",
        },
        ".MuiInputBase-input": {
          cursor: "pointer",
        },
        "&:hover": {
          cursor: "pointer",
          opacity: 0.4,
        },
      }}
      disableUnderline
      value={value ? value.format("M月D日（ddd）") : "指定なし"}
      // placeholder={dayjs(todayDate).format("M月D日（ddd）")}
      onClick={() => setOpen?.((prev) => !prev)}
      endAdornment={<ArrowDropDown />}
    />
  );
}

export function SelectDatePicker(
  props: Omit<DatePickerProps<Dayjs>, "open" | "onClose"> & {
    onOpenCallback?: () => void;
  }
) {
  const [open, setOpen] = useState(false);

  if (open && props.onOpenCallback) {
    props.onOpenCallback();
  }

  return (
    <DatePicker
      slots={{ field: SelectField, ...props.slots }}
      slotProps={{ field: { setOpen } as any }}
      {...props}
      open={open}
      disablePast
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
    />
  );
}
